import ListItemDesktop from "./ListItemDesktop";
import ListItemMobile from "./ListITemMobile";

interface Props {
  icon: JSX.Element;
  onArrowClick: () => void;
  primaryText: string;
  secondaryText: string;
}

const DialogListItem = ({ icon, onArrowClick, primaryText, secondaryText }: Props) => (
  <>
    <ListItemDesktop icon={icon} onArrowClick={onArrowClick} primaryText={primaryText} secondaryText={secondaryText} />
    <ListItemMobile icon={icon} onArrowClick={onArrowClick} primaryText={primaryText} secondaryText={secondaryText} />
  </>
);

export default DialogListItem;
